<template>
  <section>
    <!-- <umanaWaitUpdate class="onlyMov" /> -->
    <navigatorApp />
    <hr id="top" />
    <!-- Aqui van a ir las distintas vistas del menu de UmanaApp -->
    <div>
      <miPerfil v-if="$route.query.a === 'mi-perfil'" @reload="getAllInfo" />
      <calendarioSemanal v-else-if="$route.query.a === 'calendario-semanal'" />
      <clasesList v-else-if="$route.query.a === 'clases'" />
      <claseItem v-else-if="$route.query.a === 'clase'" />
      <programas v-else-if="$route.query.a === 'programas'" />
      <comunidad v-else-if="$route.query.a === 'comunidad'" />
      <programaIndividual v-else-if="$route.query.a === 'programa-individual'" />
      <planesAlimenticios v-else-if="$route.query.a === 'planes-alimenticios'" />
      <programaIndividual v-else-if="$route.query.a === 'programa-individual'" />
      <planesAlimenticios v-else-if="$route.query.a === 'planes-alimenticios'" />
      <recetas v-else-if="$route.query.a === 'recetas'" />
      <recipeModal v-else-if="$route.query.a === 'receta'" />

      <inicio v-else />

      <template v-if="live">
        <div class="liveNotification" @click="goToClass(live.id)" v-if="live.id">
          <svg class="live00" xmlns="http://www.w3.org/2000/svg" width="111" height="112" viewBox="0 0 111 112"
            fill="none">
            <path
              d="M47.1713 19.9821C41.0095 -6.66071 69.9905 -6.66071 63.8287 19.9821C69.9905 -6.66071 96.1008 5.74958 78.8389 27.1148C96.1045 5.74958 114.173 28.1114 89.2241 39.9725C114.173 28.115 120.623 56.0018 92.9315 56.0018C120.623 56.0018 114.173 83.8886 89.2241 72.0312C114.173 83.8886 96.1008 106.254 78.8389 84.8852C96.1045 106.25 69.9905 118.664 63.8287 92.0179C69.9905 118.661 41.0095 118.661 47.1713 92.0179C41.0095 118.661 14.8992 106.25 32.1611 84.8852C14.8955 106.25 -3.17345 83.8886 21.7759 72.0312C-3.17345 83.8886 -9.6227 56.0018 18.0685 56.0018C-9.6227 56.0018 -3.17345 28.115 21.7759 39.9725C-3.17345 28.115 14.8992 5.74958 32.1611 27.1184C14.8955 5.74958 41.0095 -6.66071 47.1713 19.9821Z"
              fill="url(#paint0_linear_5825_6926)" />
            <path
              d="M47.1713 19.9821C41.0095 -6.66071 69.9905 -6.66071 63.8287 19.9821C69.9905 -6.66071 96.1008 5.74958 78.8389 27.1148C96.1045 5.74958 114.173 28.1114 89.2241 39.9725C114.173 28.115 120.623 56.0018 92.9315 56.0018C120.623 56.0018 114.173 83.8886 89.2241 72.0312C114.173 83.8886 96.1008 106.254 78.8389 84.8852C96.1045 106.25 69.9905 118.664 63.8287 92.0179C69.9905 118.661 41.0095 118.661 47.1713 92.0179C41.0095 118.661 14.8992 106.25 32.1611 84.8852C14.8955 106.25 -3.17345 83.8886 21.7759 72.0312C-3.17345 83.8886 -9.6227 56.0018 18.0685 56.0018C-9.6227 56.0018 -3.17345 28.115 21.7759 39.9725C-3.17345 28.115 14.8992 5.74958 32.1611 27.1184C14.8955 5.74958 41.0095 -6.66071 47.1713 19.9821Z"
              fill="url(#paint1_linear_5825_6926)" />
            <defs>
              <linearGradient id="paint0_linear_5825_6926" x1="0" y1="56" x2="111" y2="56"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#FFE711" />
                <stop offset="1" stop-color="#96FF11" />
              </linearGradient>
              <linearGradient id="paint1_linear_5825_6926" x1="0" y1="56" x2="111" y2="56"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#FFE711" />
                <stop offset="1" stop-color="#96FF11" />
              </linearGradient>
            </defs>
          </svg>
          <svg class="live01" xmlns="http://www.w3.org/2000/svg" width="71" height="72" viewBox="0 0 71 72" fill="none">
            <path
              d="M27.0944 5.61858C26.8695 6.52465 26.1579 7.27193 24.8358 7.79502C24.2252 8.03788 23.656 8.14997 23.128 8.1453C22.0676 8.13129 21.2458 7.55215 20.7546 6.2631L20.7409 6.22574C20.5159 5.63259 20.4562 5.0768 20.571 4.55371C20.7959 3.50285 21.6039 2.67151 22.8388 2.18578C23.3759 1.97094 23.8671 1.87286 24.3492 1.86352C25.327 1.85418 26.1258 2.27919 26.7088 3.21796L25.3867 3.73638C24.9964 3.08251 24.2803 2.90503 23.2703 3.30202C22.0676 3.77374 21.535 4.53036 21.9987 5.74001L22.0033 5.75402C22.4348 6.88895 23.2979 7.10846 24.4869 6.64141C25.6437 6.18371 25.9605 5.53918 25.7677 4.67981L27.099 4.15205C27.2046 4.67981 27.2138 5.16554 27.0944 5.61858Z"
              fill="#464D5B" />
            <path
              d="M27.9529 0.705241L29.2658 0.504411L29.9131 4.86196L33.5627 4.29683L33.7463 5.53918L28.7838 6.30514L27.9529 0.705241Z"
              fill="#464D5B" />
            <path
              d="M36.3493 4.35755L35.6836 5.53918L34.2743 5.43176L37.5016 0L38.8788 0.10275L41.3164 5.96886L39.9209 5.86144L39.4205 4.59107L36.3493 4.35755ZM36.9369 3.31604L38.9752 3.47016L38.0983 1.24702L36.9369 3.31604Z"
              fill="#464D5B" />
            <path
              d="M42.9048 6.43124C42.1106 5.85677 41.8444 5.11417 41.9545 4.09133L43.3134 4.52102C43.2629 5.32901 43.8597 5.75869 44.9247 6.09497C45.9026 6.40322 46.3984 6.35184 46.5361 5.90815C46.5912 5.73534 46.5682 5.58589 46.4764 5.48313C46.2882 5.24961 45.7557 5.03944 44.686 4.63311C44.1581 4.43228 43.7312 4.22211 43.4098 3.99792C42.7671 3.56357 42.5651 3.0218 42.7946 2.26518C43.116 1.21899 44.1902 0.826674 45.9255 1.37779C47.7756 1.9616 48.5973 2.79761 48.4275 4.24079L47.0916 3.82045C47.1512 3.08251 46.582 2.75091 45.5766 2.43332C44.5758 2.11105 44.1856 2.23716 44.0709 2.62481C44.0112 2.81629 44.025 2.96108 44.2361 3.12455C44.4381 3.28801 44.8513 3.48417 45.5904 3.75039C46.2239 3.98391 46.7151 4.21277 47.0824 4.45563C47.8261 4.93202 48.0464 5.46912 47.8215 6.21173C47.468 7.37001 46.4259 7.78101 44.5529 7.19253C43.8505 6.97302 43.3042 6.72548 42.9048 6.43124Z"
              fill="#464D5B" />
            <path
              d="M48.1291 8.31344L50.8973 3.4001L55.5109 6.0903L54.9646 7.06175L51.4436 5.00675L50.8835 5.99689L53.8629 7.7343L53.3166 8.70576L50.3372 6.96834L49.7863 7.9398L53.4497 10.0742L52.885 11.0784L48.1291 8.31344Z"
              fill="#464D5B" />
            <path
              d="M55.3365 13.1007L59.3579 9.18682L63.0305 13.096L62.2363 13.8713L59.4314 10.8869L58.6188 11.6762L60.9922 14.1982L60.198 14.9735L57.8246 12.4468L57.0304 13.2221L59.9501 16.328L59.1284 17.1266L55.3365 13.1007Z"
              fill="#464D5B" />
            <path
              d="M60.3404 18.9901L59.6977 17.8832L64.4812 14.9969L65.1514 16.1458L63.6273 21.0592L63.5906 21.1386L66.9005 19.1443L67.5432 20.2418L62.7597 23.1282L62.117 22.0306L63.6549 17.0612L63.6916 16.9725L60.3404 18.9901Z"
              fill="#464D5B" />
            <path
              d="M69.2739 24.4966L69.5998 25.9118L65.9823 28.616L70.4399 29.5688L70.7613 30.9699L64.7199 29.5641L64.4169 28.2423L69.2739 24.4966Z"
              fill="#464D5B" />
            <path
              d="M66.5195 32.8101L66.5654 34.3513L69.7513 34.2532L69.7054 32.712L70.8669 32.6746L70.9954 37.0182L69.834 37.0555L69.788 35.5143L66.6021 35.6124L66.648 37.1536L65.4315 37.191L65.3029 32.8474L66.5195 32.8101Z"
              fill="#464D5B" />
            <path
              d="M71 38.7322L70.7613 40.1661L66.3955 41.2356L70.1461 43.8697L69.912 45.2896L64.876 41.6092L65.1009 40.2688L71 38.7322Z"
              fill="#464D5B" />
            <path
              d="M63.9257 46.0088C64.6878 45.2195 65.6702 45.0093 66.9097 45.5324L66.9464 45.5464C67.5248 45.7893 67.9564 46.1349 68.2502 46.5693C68.8424 47.4567 68.8837 48.6009 68.3925 49.8106C68.1446 50.4178 67.8232 50.8941 67.4192 51.2911C66.6113 52.0664 65.5738 52.2999 64.4031 51.8049L64.3526 51.7815C63.7558 51.5293 63.3151 51.1977 63.0305 50.7494C62.4613 49.89 62.475 48.7597 62.9754 47.5267C63.2325 46.9009 63.5401 46.3965 63.9257 46.0088ZM63.8201 49.0493C63.788 49.6892 64.1047 50.1936 64.876 50.5205L64.8852 50.5252C65.2891 50.6933 65.638 50.754 65.9502 50.7073C66.5608 50.6046 66.9831 50.1375 67.2999 49.3622C67.7773 48.1946 67.5799 47.3072 66.4047 46.8121L66.3955 46.8075C65.3121 46.3498 64.5409 46.8355 64.0726 47.9938C63.9119 48.3814 63.8247 48.7224 63.8201 49.0493Z"
              fill="#464D5B" />
            <path
              d="M45.5032 65.8443C45.6822 64.9289 46.3525 64.1443 47.6516 63.5511C48.2484 63.2802 48.8131 63.1354 49.341 63.1121C50.4015 63.0747 51.2507 63.6072 51.8062 64.8682L51.8246 64.9056C52.0771 65.4847 52.1689 66.0358 52.0771 66.5636C51.9026 67.6238 51.1406 68.4971 49.9286 69.0483C49.4007 69.2865 48.9187 69.4126 48.4366 69.4499C47.4634 69.5106 46.6463 69.1277 46.0173 68.2216L47.3073 67.6331C47.7297 68.2683 48.4504 68.4084 49.442 67.9554C50.6172 67.4183 51.113 66.6383 50.5897 65.4567L50.5851 65.4427C50.0985 64.3358 49.2262 64.1583 48.0648 64.686C46.9309 65.1998 46.6508 65.863 46.885 66.7084L45.5812 67.3015C45.4389 66.7831 45.4068 66.302 45.5032 65.8443Z"
              fill="#464D5B" />
            <path
              d="M44.8834 70.7997L43.5842 71.0706L42.7212 66.7504L39.1037 67.4977L38.8558 66.2693L43.7725 65.2512L44.8834 70.7997Z"
              fill="#464D5B" />
            <path
              d="M36.3309 67.5911L36.9369 66.3721L38.3508 66.4048L35.4036 72L34.0218 71.9673L31.2857 66.2366L32.6813 66.2693L33.246 67.5163L36.3309 67.5911ZM35.7984 68.6559L33.7555 68.6092L34.7425 70.7857L35.7984 68.6559Z"
              fill="#464D5B" />
            <path
              d="M29.6836 65.8537C30.5099 66.3861 30.8083 67.1147 30.7532 68.1375L29.376 67.7779C29.3852 66.9699 28.77 66.5729 27.6866 66.288C26.695 66.0311 26.2038 66.1059 26.089 66.5589C26.0431 66.7364 26.0707 66.8812 26.1671 66.9792C26.3691 67.2034 26.9108 67.3856 27.9988 67.7359C28.5359 67.9087 28.972 68.0955 29.3071 68.3057C29.9728 68.7073 30.2023 69.2351 30.0095 70.0057C29.7432 71.0659 28.6874 71.5143 26.9291 71.0566C25.0561 70.5708 24.1885 69.7769 24.2895 68.329L25.6437 68.6793C25.6208 69.4172 26.2038 69.7161 27.2229 69.9824C28.2375 70.2439 28.6185 70.0991 28.7195 69.7068C28.7654 69.5153 28.7471 69.3705 28.5267 69.2164C28.3155 69.0623 27.8932 68.8895 27.1449 68.6606C26.5022 68.4598 25.9972 68.2543 25.6208 68.0348C24.8541 67.5957 24.6062 67.0727 24.7945 66.3207C25.0883 65.1437 26.1074 64.6814 28.008 65.1718C28.7103 65.3633 29.2658 65.5828 29.6836 65.8537Z"
              fill="#464D5B" />
            <path
              d="M24.3629 64.247L21.8472 69.2958L17.105 66.8485L17.6008 65.849L21.2229 67.7172L21.7324 66.699L18.6704 65.1204L19.1662 64.1209L22.2282 65.6995L22.724 64.7001L18.9551 62.7571L19.4692 61.725L24.3629 64.247Z"
              fill="#464D5B" />
            <path
              d="M16.9306 59.8428L13.1111 63.9575L9.2457 60.2491L10.0032 59.4364L12.955 62.2714L13.7262 61.4401L11.2289 59.0394L11.9864 58.2268L14.4837 60.6274L15.2412 59.8147L12.17 56.863L12.9504 56.0223L16.9306 59.8428Z"
              fill="#464D5B" />
            <path
              d="M11.6329 54.2242L12.3353 55.2937L7.69863 58.4276L6.9733 57.316L8.24951 52.3233L8.28165 52.2439L5.07733 54.411L4.37954 53.3461L9.01616 50.2122L9.71395 51.2771L8.42855 56.3259L8.39183 56.4146L11.6329 54.2242Z"
              fill="#464D5B" />
            <path
              d="M2.43767 49.1801L2.04287 47.7836L5.51804 44.8972L1.01914 44.178L0.628928 42.7955L6.72999 43.8884L7.10184 45.1915L2.43767 49.1801Z"
              fill="#464D5B" />
            <path
              d="M4.76516 40.7312L4.64121 39.1946L1.46903 39.4562L1.59298 40.9927L0.436118 41.0861L0.0918143 36.7613L1.24867 36.6679L1.37262 38.2045L4.54481 37.9429L4.42086 36.4063L5.63281 36.3083L5.97711 40.6331L4.76516 40.7312Z"
              fill="#464D5B" />
            <path
              d="M0 35.0612L0.165266 33.6181L4.47136 32.3197L0.592202 29.8864L0.757468 28.4572L5.96793 31.8666L5.81184 33.2164L0 35.0612Z"
              fill="#464D5B" />
            <path
              d="M6.69326 27.425C5.97252 28.2517 5.00388 28.5179 3.73684 28.0602L3.70012 28.0462C3.1125 27.8313 2.66261 27.5091 2.34126 27.0934C1.70316 26.2387 1.60675 25.0991 2.03369 23.8661C2.24945 23.2449 2.54785 22.7545 2.93347 22.3389C3.70012 21.5215 4.72844 21.232 5.91743 21.6663L5.96793 21.685C6.57849 21.9045 7.03297 22.2128 7.34055 22.6425C7.95571 23.4691 7.99702 24.5994 7.56091 25.8557C7.34514 26.4956 7.06052 27.0187 6.69326 27.425ZM6.64735 24.3799C6.64735 23.74 6.30305 23.2543 5.51804 22.9694H5.50886C5.09569 22.8199 4.7468 22.7779 4.43463 22.8433C3.83325 22.9787 3.42926 23.4645 3.15382 24.2584C2.74066 25.4494 2.97937 26.3274 4.17755 26.7618L4.18673 26.7665C5.2885 27.1635 6.03679 26.6404 6.44995 25.4587C6.58768 25.0524 6.65654 24.7068 6.64735 24.3799Z"
              fill="#464D5B" />
            <path
              d="M7.80422 19.1536L7.0192 18.6679C9.84708 13.918 13.8272 9.91074 18.5281 7.08044L18.9964 7.88376C14.424 10.6393 10.5541 14.5345 7.80422 19.1536Z"
              fill="#464D5B" />
            <path
              d="M54.6892 63.467L54.1521 62.7104C57.4849 60.2678 60.299 57.246 62.5118 53.7291L63.2876 54.2335C61.0106 57.8485 58.1185 60.9543 54.6892 63.467Z"
              fill="#464D5B" />
          </svg>
          <svg class="live02" xmlns="http://www.w3.org/2000/svg" width="43" height="22" viewBox="0 0 43 22" fill="none">
            <path
              d="M26.8744 19.1614H16.1254C13.557 19.1614 11.4671 17.0924 11.4671 14.5486V7.45252C11.4671 4.90921 13.5564 2.83973 16.1254 2.83973H26.875C29.4434 2.83973 31.5333 4.90866 31.5333 7.45252V14.5486C31.5328 17.0919 29.4434 19.1614 26.8744 19.1614ZM29.3828 7.45252C29.3828 6.08288 28.2576 4.96871 26.8744 4.96871H16.1254C14.7423 4.96871 13.6171 6.08288 13.6171 7.45252V14.5486C13.6171 15.9182 14.7423 17.0324 16.1254 17.0324H26.875C28.2581 17.0324 29.3833 15.9182 29.3833 14.5486L29.3828 7.45252Z"
              fill="url(#paint0_linear_5826_8836)" />
            <path
              d="M26.2807 11.9523L19.1145 15.5006C18.7815 15.6655 18.3857 15.648 18.0687 15.4542C17.7517 15.2604 17.5588 14.9176 17.5588 14.5486V7.45252C17.5588 7.0835 17.7517 6.74122 18.0687 6.54689C18.2413 6.44098 18.4375 6.38803 18.6338 6.38803C18.7981 6.38803 18.9629 6.42515 19.1145 6.50049L26.2807 10.0488C26.6451 10.2289 26.875 10.5974 26.875 11.0008C26.8744 11.4037 26.6445 11.7722 26.2807 11.9523ZM19.7082 9.17481V12.8263L23.3958 11.0003L19.7082 9.17481Z"
              fill="url(#paint1_linear_5826_8836)" />
            <path
              d="M9.60922 17.5772C9.8992 18.0903 9.71397 18.7388 9.19576 19.026C8.67755 19.3131 8.02262 19.1297 7.73265 18.6166C6.425 16.3014 5.73368 13.6675 5.73368 11.0003C5.73368 8.33304 6.425 5.69966 7.73265 3.38453C7.92946 3.03571 8.29496 2.83973 8.67204 2.83973C8.84955 2.83973 9.02982 2.8834 9.19576 2.97511C9.71397 3.26225 9.8992 3.91077 9.60922 4.42391C7.31808 8.48044 7.31808 13.5201 9.60922 17.5772Z"
              fill="url(#paint2_linear_5826_8836)" />
            <path
              d="M33.8041 19.0254C33.2859 18.7383 33.1006 18.0898 33.3906 17.5766C35.6818 13.5201 35.6818 8.47989 33.3906 4.42336C33.1006 3.91022 33.2859 3.26171 33.8041 2.97457C33.97 2.88286 34.1503 2.83918 34.3278 2.83918C34.7043 2.83918 35.0698 3.03571 35.2672 3.38399C36.5748 5.69911 37.2661 8.3325 37.2661 10.9997C37.2661 13.667 36.5748 16.3003 35.2672 18.6155C34.9772 19.1292 34.3223 19.3126 33.8041 19.0254Z"
              fill="url(#paint3_linear_5826_8836)" />
            <path
              d="M41.6373 18.4697C41.2492 19.4982 40.7762 20.5037 40.2315 21.4585C39.9399 21.9705 39.2839 22.1512 38.7668 21.8619C38.2496 21.5731 38.0672 20.9235 38.3593 20.4115C38.8489 19.5528 39.2745 18.6482 39.6234 17.7235C41.2327 13.4617 41.2591 8.75666 39.6979 4.47632C39.3346 3.48061 38.8842 2.50892 38.3593 1.588C38.0677 1.07595 38.2502 0.426889 38.7668 0.137566C38.9338 0.0442183 39.1152 0 39.2943 0C39.6692 0 40.0336 0.194884 40.2315 0.541526C40.8153 1.56562 41.3159 2.64594 41.72 3.75301C43.4549 8.50882 43.4251 13.7352 41.6373 18.4697Z"
              fill="url(#paint4_linear_5826_8836)" />
            <path
              d="M4.64044 20.412C4.93207 20.9241 4.7496 21.5731 4.23304 21.8624C3.71593 22.1512 3.06045 21.9705 2.76827 21.459C2.18446 20.4349 1.68389 19.3546 1.2798 18.2475C-0.454547 13.4923 -0.425329 8.26645 1.36249 3.53193C1.7506 2.50401 2.2236 1.49848 2.76827 0.543165C2.96563 0.196524 3.33003 0.00163942 3.70546 0.00163942C3.88463 0.00163942 4.066 0.0458578 4.23304 0.139205C4.75015 0.427982 4.93262 1.07759 4.64044 1.58964C4.1509 2.44833 3.72531 3.35287 3.37634 4.27761C1.76659 8.53885 1.74012 13.2433 3.30192 17.5237C3.66466 18.5194 4.11506 19.4911 4.64044 20.412Z"
              fill="url(#paint5_linear_5826_8836)" />
            <defs>
              <linearGradient id="paint0_linear_5826_8836" x1="0" y1="11" x2="43" y2="11"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.23516" stop-color="#4536EF" />
                <stop offset="0.913242" stop-color="#FF00B8" />
              </linearGradient>
              <linearGradient id="paint1_linear_5826_8836" x1="0" y1="11" x2="43" y2="11"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.23516" stop-color="#4536EF" />
                <stop offset="0.913242" stop-color="#FF00B8" />
              </linearGradient>
              <linearGradient id="paint2_linear_5826_8836" x1="0" y1="11" x2="43" y2="11"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.23516" stop-color="#4536EF" />
                <stop offset="0.913242" stop-color="#FF00B8" />
              </linearGradient>
              <linearGradient id="paint3_linear_5826_8836" x1="0" y1="11" x2="43" y2="11"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.23516" stop-color="#4536EF" />
                <stop offset="0.913242" stop-color="#FF00B8" />
              </linearGradient>
              <linearGradient id="paint4_linear_5826_8836" x1="0" y1="11" x2="43" y2="11"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.23516" stop-color="#4536EF" />
                <stop offset="0.913242" stop-color="#FF00B8" />
              </linearGradient>
              <linearGradient id="paint5_linear_5826_8836" x1="0" y1="11" x2="43" y2="11"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.23516" stop-color="#4536EF" />
                <stop offset="0.913242" stop-color="#FF00B8" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </template>

    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";

import navigatorApp from "@/components/navigatorApp.vue";
import miPerfil from "@/components/webapp/miPerfil.vue";
import inicio from "@/components/webapp/inicio.vue";
import calendarioSemanal from "@/components/webapp/calendarioSemanal.vue";
import clasesList from "@/components/webapp/clasesList.vue";
import claseItem from "@/components/webapp/claseItem.vue";
import programas from "@/components/webapp/programas.vue";
import comunidad from "@/components/webapp/comunidad.vue";
import umanaWaitUpdate from "@/components/webapp/umanaWaitUpdate.vue";
import programaIndividual from "@/components/webapp/programaIndividual.vue";
import planesAlimenticios from "@/components/webapp/planesAlimenticios.vue";
import recetas from "@/components/webapp/recetas.vue";
import recipeModal from "@/components/recipeModal.vue";

export default {
  components: {
    navigatorApp,
    miPerfil,
    inicio,
    calendarioSemanal,
    clasesList,
    claseItem,
    programas,
    comunidad,
    umanaWaitUpdate,
    planesAlimenticios,
    programaIndividual,
    recetas,
    recipeModal,
  },
  async created() {
 
    await this.getAllInfo();
    this.getAllInfolve("live-event/current");

  },
  computed: {
    identity() {
      const data = this.$store.getters["admin/getIdentity"];
      if (!data?.id) return [];

      return data;
    },
    userInfo() {
      const data = this.$store.getters["usuarios/data"];
      if (!data?.id) return [];

      return data;
    },
    live() {
      return this.$store.getters["live/data"];
    },
  },
  methods: {
    ...mapActions("usuarios", ["getInfoIdentity", "getInfoByIdUsr"]),
    ...mapActions('live', ['getAllInfolve']),

    async getAllInfo() {  
        if (! this.identity?.id) {
        this.$router.push('/elige-tu-membresia');
        return;
      }
      await this.getInfoByIdUsr({
        id: this.identity.id,
        option: "user",
      });
      const find = this.userInfo?.memberships.find(item => item.status === 'Pagado' || item.status === 'Pendiente')
      if (
        (this.userInfo?.memberships?.length === 0 || !find) &&
        !['admin', 'legrafica'].includes(this.userInfo.role)
      ) {
        this.$router.push('/elige-tu-membresia');
      }
    },
    goToClass(id) {
      const idClass = id

      this.$router.push({ path: '/web-app', query: { a: 'clase', id: idClass, cN: 'ClaseEnVivo' } });
    },
  },
}
</script>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  padding: 2.083333vw;
  min-height: 100vh;
  gap: 2.083333vw;
}

hr {
  height: 0.069444vw;
  background-color: #e3e3e9;
  border: 0;
}

.onlyMov {
  display: none;
}

@media (max-width: 530px) {
  .onlyMov {
    display: block;
    z-index: 5000;
  }

  section {
    padding: 30px 15px;
    gap: 0;
  }

}

.liveNotification {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  height: 112px;
  width: 112px;
  cursor: pointer;
}

.liveNotification:hover .live01 {
  animation-play-state: paused;
  transition: animation-play-state 0.5s ease;
}

.live00,
.live02,
.live01 {
  position: absolute;
  height: 112px;
  width: 112px;
}

.live01 {
  scale: 0.65;
  animation: rotate 20s linear infinite;

}

.live02 {
  scale: 0.4;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
